import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { doLogout } from './layout/layoutHeader';
import { JSX, useEffect, useState } from 'react';

const IDLE_TIMEOUT = 1000 * 60 * 60; // 60 minutes

/**
 * Simple implementation of idle timeout dialog (show dialog after N minutes of inactivity)
 */
const IdleTimeoutDialog = (): JSX.Element => {
  const [idleDialogVisible, setIdleDialogVisible] = useState(false);

  const handleClose = (): void => {
    doLogout();
    setIdleDialogVisible(false);
  };

  useEffect(() => {
    let timeout = setTimeout(() => setIdleDialogVisible(true), IDLE_TIMEOUT);

    const documentClickHandler = (): void => {
      clearTimeout(timeout);
      timeout = setTimeout(() => setIdleDialogVisible(true), IDLE_TIMEOUT);
    };

    document.addEventListener('click', documentClickHandler);

    return () => {
      clearTimeout(timeout);
      document.removeEventListener('click', documentClickHandler);
    };
  }, []);

  return (
    <Dialog open={idleDialogVisible} onClose={handleClose}>
      <DialogTitle>Your session has expired</DialogTitle>
      <DialogContent>
        <DialogContentText>For your security, we are going to sign you out.</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleClose}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IdleTimeoutDialog;
